
import axios from 'axios';
import toast from 'react-hot-toast';

const baseURL2 = 'https://connectifie.gamequiz.live';
const baseURL = 'https://mysteryshopper.connectifie.com/api/v1.0';

export const signinEvaluator = async (formData) => {
    try {
        toast.remove();
        toast.loading('Signing you in...');
        const { data } = await axios.post(`${baseURL2}/api/login`, formData);
        // const { data } = await axios.post(`${baseURL}/evaluator/login`, formData);
        toast.remove();
        console.log({data})

        // Update to check if token exists
        data.success= !!data.token
        const payload = data.success ? {...data, 
            // ...data.user[0],
             token: data.token} : {};
        data.success ? toast.success('You are now signed in', { duration: 7000 }) : toast.error('Login Failed! Try again');
        Object.entries({...payload}).forEach(data=> {
            sessionStorage[`${data[0]}`] = data[1];
        })
        sessionStorage.setItem("token", data.token)
        sessionStorage.setItem("userId", data.userId)
        sessionStorage.setItem("username", data?.user?.firstName)
        sessionStorage.setItem("orgId", data?.orgId)
        return data.success ? payload : {token: false};
    } catch (error) {
        toast.remove();
        console.log(error.response);
        toast.error(error.message);
        return null;
    }
}; 
